import React, { useState, useEffect } from 'react';
import { Link, location, useLocation } from 'react-router-dom';

import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';

import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import Nav from './Nav';
import UserProfile from './UserProfile';
import HelpCenter from './HelpCenter';
import Logout from './Logout';

import useGlobalStatus from '../../hook/useGlobalStatus';

import {
  BoxFlexStartCenter
} from '../../components/customComponent/box';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';

import logo from '../../Logo.svg';
import {
  MenuOutlinedIcon,
  LogoutOutlinedIcon
} from '../../constants/images';
import theme from '../../theme';


const TopbarNormal = (props) => {
  const { userData, currentMedia, setCurrentMedia } = props;
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const [menuOpen, setMenuOpen] = useState(false);
  const [colorSystem, setColorSystem] = useState('');

  const { entryPath, setEntryPath } = useGlobalStatus();

  const toggleDrawer = (newOpen) => () => {
    setMenuOpen(newOpen);
  };

  useEffect(() => {
    if (location.pathname === urlConstants.PAGE_FB_SEND_LIST ||
      location.pathname === urlConstants.PAGE_FB_CREATE_DATA) {
      setColorSystem(theme.palette.facebook.main);

    } else if (location.pathname === urlConstants.PAGE_GOOGLE_SEND_LIST ||
      location.pathname === urlConstants.PAGE_GOOGLE_CREATE_DATA) {
      setColorSystem(theme.palette.google.main);

    } else if (location.pathname === urlConstants.PAGE_LINE_SEND_LIST ||
      location.pathname === urlConstants.PAGE_LINE_CREATE_DATA) {
      setColorSystem(theme.palette.line.main);
      
    } else {
      setColorSystem(theme.palette.system.main);
    }
  }, [entryPath])


  return (
    <>
      {/* {
        isDesktop && */}
        <Box pt={6} >
          <AppBar
            id="appbar"
            position="fixed"
            sx={{
              boxShadow: 'none',
              zIndex: 2000,
              boxShadow: '0px 2px 16px rgba(107, 117, 128, 0.25)',
              backgroundColor: colorSystem,
              paddingRight: {
                xl: 10,
                lg: 10,
                md: 0
              },
            }}
          >
            <Toolbar
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: {
                  xs: '56px'
                }
              }}
            >
              <BoxFlexStartCenter>
                <Box>
                  <Link to="/" style={{ display: 'block', width: '100%' }}>
                    <img src={logo} alt={basicConstants.PRODUCT_NAME} style={{ width: '180px' }} />
                  </Link>
                </Box>
              </BoxFlexStartCenter>

            </Toolbar>
          </AppBar>

        </Box>
      {/* } */}

      {/* {
        isMobile &&
        <Box pt={10}>
          <AppBar
            id="appbar"
            position="fixed"
            sx={{
              boxShadow: 'none', zIndex: 2000,
              backgroundColor: colorSystem,
            }}
          >
            <Toolbar
              sx={{
                minHeight: '64px'
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  left: '16px',
                }}
              >
                <MenuOutlinedIcon
                  onClick={toggleDrawer(!menuOpen)}
                  sx={{
                    color: '#fff'
                  }}
                />
              </Box>

              <Box sx={{ mx: 'auto' }}>
                <Link to="/" style={{ display: 'block', width: '100%' }}>
                  <img src={logo} alt={basicConstants.PRODUCT_NAME} style={{ width: '180px' }} />
                </Link>
              </Box>
            </Toolbar>
          </AppBar>


        </Box>
      } */}

    </>
  )
}

export default TopbarNormal;
